module.exports = __webpack_public_path__ + "img/MASTER_ENG_VP_Handbook_Web23.c3eea5fa.jpg";